export default __webpack_public_path__ + "static/media/MazdaFavicon.7acaf6bf.ico";